module.exports = __webpack_public_path__ + "img/syndic.433f7c0.png";